import * as ReactRedux from 'react-redux';
import { checkEmailAvailability } from '../admin/signup.actions';
import StaffComponent from './StaffComponent';
import { AppState } from '../app/app.types';
import { registerStaffAccount, updateStaffAccount, deleteStaffAccount } from './Actions';
import { StaffRequest } from './Types';
import { getBusiness } from '../business/business.actions';

const mapDispatchToProps = (dispatch: Function) => {
  return {
    getBusiness: () => dispatch(getBusiness()),
    checkEmailAvailability: (email: string) => dispatch(checkEmailAvailability(email)),
    registerStaffAccount: (request: StaffRequest) => dispatch(registerStaffAccount(request)),
    updateStaffAccount: (request: StaffRequest) => dispatch(updateStaffAccount(request)),
    deleteStaffAccount: (request: StaffRequest) => dispatch(deleteStaffAccount(request))
  };
};

const mapStateToProps = (state: AppState) => {
  return {
    authState: state.authState,
    adminState: state.adminState,
    signupState: state.signupState,
    businessState: state.businessState
  };
};

const Staff = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(StaffComponent);

export default Staff;



// WEBPACK FOOTER //
// ./src/staff/Staff.tsx